define("Tavano.TTVideoImageGallery.TTVideoImageGallery", [
  "Tavano.TTVideoImageGallery.TTVideoImageGallery.View",
  "underscore",
  "jQuery",
], function (TTVideoImageGalleryView, _, jQuery) {
  "use strict";

  return {
    mountToApp: function mountToApp(container) {
      /** @type {LayoutComponent} */
      var layout = container.getComponent("Layout"),
        pdp = container.getComponent("PDP"),
        self = this;

      this.vidArr = [];
      this.isVidClicked = false;
      this.vidIndex = 0;

      if (layout) {
        container.getLayout().on("afterAppendView", function () {
          var imageGalleryChildView =
              container
                .getLayout()
                .currentView.getChildViewInstance("Product.ImageGallery") || {},
            itemInfo = pdp.getItemInfo(),
            origImages = imageGalleryChildView
              ? imageGalleryChildView.images
              : [];

          var ytIds = [];

          // Collect all video fields
          var videoOne =
            itemInfo && itemInfo.item ? itemInfo.item.custitem_tab_video : "";
          var videoTwo =
            itemInfo && itemInfo.item ? itemInfo.item.custitem_tab_video_2 : "";
          var videoThree =
            itemInfo && itemInfo.item ? itemInfo.item.custitem_tab_video_3 : "";
          var videoFour =
            itemInfo && itemInfo.item ? itemInfo.item.custitem_tab_video_4 : "";

          // Extract video IDs from all fields
          var videoFields = [videoOne, videoTwo, videoThree, videoFour];
          
          _.each(videoFields, function(videoField) {
            if (videoField) {
              var videoId = videoField.match(/embed\/([a-zA-Z0-9_-]+)/);
              if (videoId && videoId[1]) {
                ytIds.push(videoId[1]);
              }
            }
          });

          // Check if youtube videos are already added to avoid duplicates
          _.each(ytIds, function (ids) {
            var isAdded = false;
            _.each(origImages, function (img) {
              if (img.ytId == ids) {
                return (isAdded = true);
              }
            });

            if (!isAdded) {
              origImages = origImages || [];
              origImages.push({
                altimagetext: "",
                url: "https://img.youtube.com/vi/" + ids + "/0.jpg",
                isVideo: true,
                ytId: ids,
              });

              // FIX #2: Create a new object for each video instead of reusing
              var vidObj = {};
              vidObj[origImages.length - 1] = ids;
              self.vidArr.push(vidObj);
            }
          });

          // Attach event listeners for pager and arrows
          self.attachEventToPager(container);
          self.attachEventToArrows(container);

          // Force slider to show image clicked by user
          if (self.isVidClicked) {
            setTimeout(function () {
              imageGalleryChildView.$slider.goToSlide(self.vidIndex);
            });
          }
        });

        // FIX #1: Add both click and touchend events for mobile support
        layout.addToViewEventsDefinition(
          "ProductDetails.ImageGallery.View",
          'click [data-action="openytvid"]',
          function (event) {
            event.preventDefault();
            self.vidIndex = jQuery(event.currentTarget).data("vidindex");
            self.isVidClicked = true;

            self.displayVideoModal(
              container,
              jQuery(event.currentTarget).data("vidid")
            );
          }
        );

        layout.addToViewEventsDefinition(
          "ProductDetails.ImageGallery.View",
          'touchend [data-action="openytvid"]',
          function (event) {
            event.preventDefault();
            self.vidIndex = jQuery(event.currentTarget).data("vidindex");
            self.isVidClicked = true;

            self.displayVideoModal(
              container,
              jQuery(event.currentTarget).data("vidid")
            );
          }
        );
      }
    },

    attachEventToPager: function (container) {
      var self = this;

      jQuery(document).ready(function () {
        var pagerEl = document.getElementsByClassName("bx-pager-link");

        _.each(pagerEl, function (pager) {
          jQuery(pager).on("click", function (e) {
            var clickVid = jQuery(e.currentTarget).data("slide-index");

            self.vidIndex = clickVid;
            self.isVidClicked = true;

            var galleryView = container
              .getLayout()
              .currentView.getChildViewInstance("Product.ImageGallery");

            if (
              !galleryView ||
              !galleryView.images ||
              !galleryView.images[clickVid]
            ) {
              return;
            }

            var clickedImage = galleryView.images[clickVid];

            // Do nothing if this is the 360 slide
            if (clickedImage.is360 === true) {
              return;
            }

            // Only open modal if this slide is a video
            if (clickedImage.isVideo && clickedImage.ytId) {
              self.displayVideoModal(container, clickedImage.ytId);
            }
          });
        });
      });
    },

    // FIX #3: Add event listener for arrow navigation
    attachEventToArrows: function (container) {
      var self = this;

      jQuery(document).ready(function () {
        // Listen for slider changes (arrows, swipes, etc.)
        setTimeout(function() {
          var galleryView = container
            .getLayout()
            .currentView.getChildViewInstance("Product.ImageGallery");

          if (galleryView && galleryView.$slider) {
            // Listen for slide changes
            galleryView.$slider.on('onSlideAfter', function($slideElement, oldIndex, newIndex) {
              self.vidIndex = newIndex;
              
              if (!galleryView.images || !galleryView.images[newIndex]) {
                return;
              }

              var currentSlide = galleryView.images[newIndex];

              // Skip 360 slides
              if (currentSlide.is360 === true) {
                return;
              }

              // Auto-open video modal when navigating to video slide
              if (currentSlide.isVideo && currentSlide.ytId) {
                self.isVidClicked = true;
                self.displayVideoModal(container, currentSlide.ytId);
              }
            });
          }
        }, 500);
      });
    },

    displayVideoModal: function (container, videoid) {
      var videoGallery = new TTVideoImageGalleryView({
        application: container,
        vidid: videoid,
      });

      container.getLayout().showInModal(videoGallery);
    },
  };
});
